var map = {
	"../account/account.module.ngfactory": [
		"rP6u",
		0,
		17
	],
	"../custom-treatments/custom-treatments.module.ngfactory": [
		"VLYm",
		0,
		16
	],
	"../descriptions/descriptions.module.ngfactory": [
		"SMQn",
		0,
		14
	],
	"../documents/documents.module.ngfactory": [
		"Fynn",
		0,
		13
	],
	"../patients/patients.module.ngfactory": [
		"bz/t",
		0,
		12
	],
	"../plan-editor/plan-editor.module.ngfactory": [
		"aqeQ",
		0,
		11
	],
	"../plans/plans.module.ngfactory": [
		"pH5m",
		0,
		10
	],
	"../prices/prices.module.ngfactory": [
		"62+I",
		0,
		9
	],
	"../settings/settings.module.ngfactory": [
		"9GpX",
		8
	],
	"./auth/auth.module.ngfactory": [
		"mPPh",
		0,
		1
	],
	"./dashboard/dashboard.module.ngfactory": [
		"oeHk",
		0,
		15
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "YuZA";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /app/src/$$_lazy_route_resource lazy
// module id = YuZA
// module chunks = 18